import {combineReducers} from "redux";
import products from './products';
import cart from './cart';
import branch from './branch';
import toolbar from "./toolbar";

export default combineReducers({
    products , cart , branch , toolbar
});